import React, { useMemo, ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useStyles } from './ecp-locator.styles';
import { InternalLinks } from '../../../../../constants';
import ecpPreviewMobile from '../../../../../assets/images/ecp-preview/ecp-preview-mobile.png';
import ecpPreview from '../../../../../assets/images/ecp-preview/ecp-preview.png';
import { ContentWrapper } from '../../../../common/content-wrapper';

export const EcpLocator = ({ isLoggedIn }: { isLoggedIn: boolean }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  const image = useMemo(() => {
    return isDesktop ? {
      src: ecpPreview,
      width: 377,
      height: 225,
    } : {
      src: ecpPreviewMobile,
      width: 377,
      height: 225,
    };
  }, [isDesktop]);

  const title = useMemo(() => {
    return isLoggedIn ? 'ecpPreview.title' : 'ecp.preview.title';
  }, [isLoggedIn]);

  const button = useMemo(() => {
    return isLoggedIn ? 'ecpPreview.button' : 'ecp.preview.button';
  }, [isLoggedIn]);

  return (
    <ContentWrapper>
      <section
        data-testid="ecp-locator-landing-wrapper" // Don't remove data-testid, it is used by Yandex Metrica
        aria-label={intl.formatMessage({ id: 'ecp.landing.section.ariaLabel' })}
        className={classes.root}
      >
        <a
          data-testid="inner-container"
          className={classes.container}
          href={InternalLinks.ecpLocator}
        >
          <div className={classes.content}>
            <h2 data-testid="ecp-locator-landing-title" className={classes.sectionTitle}>
              {intl.formatMessage({ id: title }, { linebreak: <br />, noBreak: <>&nbsp;</> })}
            </h2>
            {isLoggedIn && (
              <p
                data-testid="ecp-locator-landing-description"
                className={classes.description}
              >
                {intl.formatMessage(
                  { id: 'ecpPreview.description' },
                  { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
                )}
              </p>
            )}
            {/* Don't remove data-testid, it is used by Yandex Metrica */}
            <span data-testid="ecp-locator-landing-button" className={classes.button}>
              <FormattedMessage id={button} />
            </span>
          </div>
          <div className={classes.imgContainer} data-testid="ecp-map-image" aria-hidden="true">
            <img src={image.src} alt="" width={image.width} height={image.height} />
          </div>
        </a>
      </section>
    </ContentWrapper>
  );
};
